import { getDicts } from '@/api/system/dict/data'
import { selectAllBusinessType } from '@/api/scrm/custbusinesstype'
import { getTwoLevelIndustryList } from '@/api/system/qqAdIndustry'
// import { listType } from "@/api/scrm/custservicetype";
import { getSourceTree } from '@/api/scrm/mycust'
import store from '../store'
import { handleTree } from '@/utils/util'
// import { selectAllCustLevel } from "@/api/scrm/custlevel";
export function getDict() {
  // 性别
  getDicts('sys_user_sex').then(res => {
    store.commit('setSex', res.data)
  })
  // 状态
  getDicts('sys_normal_disable').then(res => {
    store.commit('setStatus', res.data)
  })
  // 客户类型
  getDicts('crm_mycust_type').then(res => {
    store.commit('setCrmCustType', res.data)
  })
  // 客户状态
  getDicts('crm_cust_status').then(res => {
    store.commit('setCustStatus', res.data)
  })
  // 客户等级
  // selectAllCustLevel(null).then(res => {
  //   store.commit('setCustLevel', res.data);
  // });
  // 客户来源
  // getDicts('crm_cust_source').then(res => {
  //   store.commit('setCustSource', res.data)
  // })
  getSourceTree().then(res => {
    store.commit('setCustSource', res.rows.map(item => { return { dictLabel: item.custSourceName, dictValue: item.custSourceId } }))
  })
  // 客户回访类型
  getDicts('crm_cust_visit_type').then(res => {
    store.commit('setCustVisitType', res.data)
  })
  // 支付方式
  getDicts('pay_mode').then(res => {
    store.commit('setPayMode', res.data)
  })
  // 支付方式(合同)
  getDicts('concontract_pay_mode').then((res) => {
    store.commit('setContractPayMode', res.data)
  })
  // 产品类型
  getDicts('crmcustorder_business_type').then(res => {
    store.commit('setBusinessType', res.data)
  })
  // 产品类型-树
  selectAllBusinessType().then(res => {
    store.commit('setBusinessTypeTree', handleTree(res.data, 'businessTypeId'))
  })
  // 业务类型-树
  // listType().then(res => {
  //   store.commit('setServiceTypeTree',handleTree(res.rows, "serviceTypeId"));
  // });
  // 产品类型(合同)
  getDicts('crmcontract_business_type').then((res) => {
    store.commit('setContractBusinessType', res.data)
  })
  // 审批状态
  getDicts('sp_status').then(res => {
    store.commit('setSpStatus', res.data)
  })
  // 合同状态
  getDicts('concontract_contract_status').then(res => {
    store.commit('setContractStatus', res.data)
  })
  // 合同类型
  getDicts('concontract_contract_type').then(res => {
    store.commit('setContractType', res.data)
  })
  // 投放类型
  getDicts('crmcustorder_launch_type').then(res => {
    store.commit('setCustOrderLaunchType', res.data)
  })
  // 商机状态
  getDicts('crm_cust_bo_status').then((res) => {
    store.commit('setCustBoStatus', res.data)
  })
  // 获取行业（前2级）
  getTwoLevelIndustryList().then((res) => {
    store.commit('setIndustry', handleTree(res.data, 'systemIndustryId'))
  })
  // 合同附件类型 file_type
  getDicts('file_type').then((res) => {
    store.commit('setFileType', res.data)
  })
  // 合同归档状态
  getDicts('con_is_return').then((res) => {
    store.commit('setIsReturn', res.data)
  })
}
